import { storage } from '@/common/libs/storage/storage.js';

const token = new class {	
	set(token) {
		return storage.set('token', token.toString());
	}
	
	get() {
		return storage.get('token');
	}
	
	remove() {
		return storage.remove('token');
	}
}

export {
	token
};